export default __webpack_public_path__ + "static/cheer-shoes-square-4e8c4adecc56f248a5d27d5e81ba6d65.png";